import { CheckIcon } from "@heroicons/react/20/solid";
import { SecondaryCompactButton } from "components/ui/secondary-button";
import React from "react";

interface WizardStepperProps {
    steps: readonly string[];
    currentIndex: number;
    onSelect: (index: number) => void;
}

export const WizardStepper: React.FC<WizardStepperProps> = props => {
    const { steps, currentIndex, onSelect } = props;

    return (
        <nav className="flex items-center gap-2 flex-wrap">
            {steps.map((label, index) => (
                <React.Fragment key={label}>
                    {index > 0 ? (
                        <div
                            className={`hidden sm:block h-px flex-1 ${
                                index <= currentIndex ? "bg-brand-400" : "bg-gray-200"
                            }`}
                        />
                    ) : null}
                    <SecondaryCompactButton
                        type="button"
                        selected={index === currentIndex}
                        onClick={() => onSelect(index)}>
                        <span className="inline-flex items-center gap-1.5">
                            <span className="inline-flex items-center justify-center min-w-[1.25rem] rounded-full bg-black/10 px-1 text-[10px] tabular-nums leading-4">
                                {index < currentIndex ? (
                                    <CheckIcon className="w-3 h-3" />
                                ) : (
                                    index + 1
                                )}
                            </span>
                            {label}
                        </span>
                    </SecondaryCompactButton>
                </React.Fragment>
            ))}
        </nav>
    );
};
